import React, { memo, useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import {
    Calendar,
    GoogleDocs,
    HomeAltSlimHoriz,
    MenuScale,
    MultiplePagesEmpty,
} from "iconoir-react";
import { useLocation, useNavigate } from "react-router-dom";
// firebase
import "firebase/messaging";
// Other
import { inject, observer } from "mobx-react";
import { useSSO, vapidKey } from "../config";

import { useKeycloak } from "@react-keycloak/web";
import { app, defaultMessaging } from "../firebase";
import { getMessaging, getToken } from "firebase/messaging";
import {
    ACL_ACTION_TYPE,
    MODULE_CODE,
    VAN_PHONG_DIEN_TU,
} from "../utils/constants";
import Message from "../components/common/Message";

const ItemMenu = ({ children }) => (
    <span className="relative text-sm font-bold text-black after:absolute after:w-5 after:h-[2px] after:bg-[#0073C7] after:left-1/2 after:-translate-x-1/2 after:bottom-[-8px] after:rounded-sm">
        {children}
    </span>
);

const sortCommands = (a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    let comparison = 0;
    if (nameA > nameB) {
        comparison = 1;
    } else if (nameA < nameB) {
        comparison = -1;
    }
    return comparison;
};
const MainLayout = ({
    initialValue,
    children,
    notificationStore,
    authenticationStore,
    moduleStore,
    aclStore,
    accountStore,
    commandStore,
}) => {
    const messaging = getMessaging() || defaultMessaging;
    useEffect(() => {
        if (!localStorage.getItem("FCMToken")) {
            getToken(messaging, { vapidKey: vapidKey })
                .then((currentToken) => {
                    if (currentToken) {
                        localStorage.setItem(
                            "FCMToken",
                            JSON.stringify(currentToken)
                        );
                        notificationStore
                            .sendTokenToSever(currentToken)
                            .then((res) => console.log(res))
                            .catch((err) => console.log(err.vi));
                    } else {
                        console.log(
                            "No registration token available. Request permission to generate one."
                        );
                    }
                })
                .catch(() => console.log("You have blocked notifications!"));
        }
    }, []);
    //
    const [value, setValue] = React.useState(initialValue);
    const ref = React.useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const resetTab = () => {
        switch (location.pathname) {
            case "/":
                return setValue(0);
            case "/company-work-schedule":
                return setValue(1);
            case "/internal-document/incoming-document":
                return setValue(2);
            case "/work":
                return setValue(3);
            case "/menu":
                return setValue(4);
            default:
                return navigate("#");
        }
    };

    // ALC & Module
    const { currentUser, isAccountAdmin, isSuperAdmin } = authenticationStore;
    const { aclActionsByUser } = aclStore;
    const [message, setMessage] = useState({ isOpen: false });
    const { accountList } = accountStore;
    const { commandList } = commandStore;

    const isCurrentUserHasCommand =
        currentUser?.commands && currentUser.commands.length !== 0;

    useEffect(() => {
        if (isCurrentUserHasCommand) {
            currentUser.commands.forEach((userCommand) => {
                commandList.length !== 0 &&
                    commandList.forEach((command) => {
                        if (command.code === userCommand.code) {
                            userCommand.url = command.url;
                            userCommand.description = command.description;
                            userCommand.image = command.image;
                        }
                    });
                accountList.length !== 0 &&
                    accountList.forEach((account) => {
                        if (account.command.code === userCommand.code) {
                            userCommand.account_name = account.account_name;
                            userCommand.id = account.id;
                            userCommand.password = account.password;
                        }
                    });
            });
        }
    }, [
        currentUser,
        JSON.stringify(commandList),
        JSON.stringify(accountList),
        isCurrentUserHasCommand,
    ]);

    const isAccessControl = (moduleCode, accessControlType) => {
        if (isSuperAdmin) return true;
        if (!moduleStore.checkAccessModule(moduleCode)) return false;
        if (accessControlType)
            return (
                isAccountAdmin ||
                !!aclActionsByUser.find(
                    (item) => item.code === accessControlType
                )?.status
            );
        return true;
    };

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        switch (newValue) {
            case 0:
                return navigate("/");
            case 1:
                if (
                    isAccessControl(
                        MODULE_CODE.lich_co_quan,
                        ACL_ACTION_TYPE.menu__WORK_SCHEDULE
                    )
                ) {
                    return navigate("/company-work-schedule");
                }
                setMessage({ isOpen: true, severity: "error" });
                resetTab();
                return false;
            case 2:
                if (
                    isAccessControl(MODULE_CODE.van_ban) &&
                    isCurrentUserHasCommand &&
                    currentUser.commands
                        .slice()
                        .sort(sortCommands)
                        .some((item) => item.code === VAN_PHONG_DIEN_TU) &&
                    isAccessControl(
                        MODULE_CODE.van_ban_noi_bo,
                        ACL_ACTION_TYPE.menu__INTERNAL_DOCUMENT
                    )
                ) {
                    if (
                        aclStore.checkAccessControlAction(
                            ACL_ACTION_TYPE.tab_vb_den__INTERNAL_DOCUMENT
                        )
                    )
                        return navigate("/internal-document/incoming-document");
                    if (
                        aclStore.checkAccessControlAction(
                            ACL_ACTION_TYPE.tab_vb_di__INTERNAL_DOCUMENT
                        )
                    )
                        return navigate("/internal-document/outgoing-document");
                }
                setMessage({ isOpen: true, severity: "error" });
                resetTab();
                return false;
            case 3:
                if (
                    isAccessControl(
                        MODULE_CODE.cong_viec,
                        ACL_ACTION_TYPE.menu__WORK
                    )
                ) {
                    return navigate("/work");
                }
                setMessage({ isOpen: true, severity: "error" });
                resetTab();
                return false;

            case 4:
                return navigate("/menu");
            default:
                return navigate("#");
        }
    };
    return (
        <>
            <Box
                sx={{
                    pb: 7,
                    "& .Mui-selected": {
                        backgroundColor: "white !important",
                    },
                }}
                ref={ref}
            >
                <CssBaseline />
                <List>
                    <div className="pt-6 pb-14">{children}</div>
                </List>
                <Paper
                    sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
                    elevation={3}
                    className="border-none shadow-none rounded-t-[30px]"
                >
                    <BottomNavigation
                        showLabels
                        value={value}
                        onChange={handleChangeTab}
                        className="min-h-[96px] rounded-t-[30px] shadow-[0px_-2px_12px_rgba(192,188,188,0.4)]"
                    >
                        <BottomNavigationAction
                            className="p-0 pl-7 whitespace-nowrap"
                            label={
                                value === 0 ? (
                                    <ItemMenu>Trang chủ</ItemMenu>
                                ) : (
                                    ""
                                )
                            }
                            icon={
                                value === 0 ? (
                                    ""
                                ) : (
                                    <HomeAltSlimHoriz color="black" />
                                )
                            }
                        />
                        <BottomNavigationAction
                            className="p-0 whitespace-nowrap "
                            label={
                                value === 1 ? (
                                    <ItemMenu>Lịch cơ quan</ItemMenu>
                                ) : (
                                    ""
                                )
                            }
                            icon={value === 1 ? "" : <Calendar color="black" />}
                        />
                        <BottomNavigationAction
                            className="p-0 whitespace-nowrap"
                            label={
                                value === 2 ? <ItemMenu>Văn bản</ItemMenu> : ""
                            }
                            icon={
                                value === 2 ? "" : <GoogleDocs color="black" />
                            }
                        />
                        <BottomNavigationAction
                            className="p-0 whitespace-nowrap"
                            label={
                                value === 3 ? (
                                    <ItemMenu>Công việc</ItemMenu>
                                ) : (
                                    ""
                                )
                            }
                            icon={
                                value === 3 ? (
                                    ""
                                ) : (
                                    <MultiplePagesEmpty color="black" />
                                )
                            }
                        />
                        <BottomNavigationAction
                            className="p-0 pr-7 whitespace-nowrap"
                            label={value === 4 ? <ItemMenu>Menu</ItemMenu> : ""}
                            icon={
                                value === 4 ? "" : <MenuScale color="black" />
                            }
                        />
                    </BottomNavigation>
                </Paper>
            </Box>
            <Message
                message={
                    "Bạn không có quyền truy cập trang này, vui lòng liên hệ admin"
                }
                openMessage={message.isOpen}
                severity={message.severity}
                closeMessage={() => {
                    setMessage({ isOpen: false });
                }}
            />
        </>
    );
};

export default memo(
    inject(
        "notificationStore",
        "authenticationStore",
        "moduleStore",
        "aclStore",
        "accountStore",
        "commandStore"
    )(observer(MainLayout))
);
